import { DropType } from '../../constants/drop-types';
import type { LiveDropInfoResponse } from '#lib/features/live-drop-info/types.js';

/**
 * On /primary routes, cart items from application or generic drops should be hidden.
 * This function returns true if a cart item should be visible given the current context.
 */
export const isVisibleCartItem = (
	groupId: string | null | undefined,
	{
		isOnPrimaryRoute,
		liveDropInfo,
		dropTypes,
	}: {
		isOnPrimaryRoute: boolean;
		liveDropInfo: LiveDropInfoResponse | undefined;
		dropTypes: Record<string, { type: string; dropPageSlug?: string }> | null;
	}
): boolean => {
	if (!isOnPrimaryRoute) return true;

	const primaryDrop = liveDropInfo?.primary[groupId as string];
	if (!primaryDrop?.slug) return true;

	if (primaryDrop.isGeneric) return false;

	return dropTypes?.[primaryDrop.slug]?.type !== DropType.Application;
};
